import { Injectable } from '@angular/core';
import { NodeService } from './node.service';
import { ColorService } from './color.service';
import { CollapseService } from './collapse.service';
import { ToolbarService } from './toolbar.service';
import { EventService } from './event.service';
import $ from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class MutualService {

  constructor(private nodeService: NodeService, private toolbarService: ToolbarService,
    private colorService: ColorService, private collaspeService: CollapseService, private eventService: EventService) {
    toolbarService = this.toolbarService;
    nodeService = this.nodeService;
    colorService = this.colorService;
    collaspeService = this.collaspeService;

  }


  // PARTIE TOOLBAR
  createToolbarNode(idNode, that) {

    const it = this;
    const nodeSelected = this.nodeService.getNodeById(idNode, that);

    const divGlobal = document.createElement('div');
    divGlobal.style.border = 'none';
    // divGlobal.style.cursor = 'pointer';

    divGlobal.id = 'toolbar-' + idNode;
    document.body.appendChild(divGlobal);

    const divToolbar = document.createElement('div');
    divToolbar.className = 'mindmap-toolbar';
    divGlobal.appendChild(divToolbar);

    const divOption = document.createElement('div');
    divOption.id = 'options';
    divToolbar.appendChild(divOption);

    const divAction = document.createElement('div');
    divAction.className = 'actions';
    divToolbar.appendChild(divAction);

    if (nodeSelected.data('detached') === 'false') {
      const elmtAdd = document.createElement('span');
      elmtAdd.style.cursor = 'pointer';
      elmtAdd.setAttribute('class', 'material-icons');
      elmtAdd.innerHTML = 'add_circle_outline';
      elmtAdd.setAttribute('data-node-id', idNode);

      elmtAdd.onclick = function (event: any) {
        const nodeId = event.target.dataset.nodeId;
        const node = it.nodeService.getNodeById(nodeId, that);
        it.nodeService.openModalAddNode(node, that);

      };
      divAction.appendChild(elmtAdd);

    }


    if (idNode !== 'n') {
      const elmtRemove = document.createElement('i');
      elmtRemove.style.cursor = 'pointer';
      elmtRemove.setAttribute('class', 'material-icons');
      elmtRemove.innerHTML = 'delete';

      elmtRemove.onclick = function () {
        that.openModalDeleteNode(nodeSelected);

      };
      divAction.appendChild(elmtRemove);
    }

    if (this.collaspeService.isCollapsable(nodeSelected) && nodeSelected.data('collapsed') === 'false') {
      const elmtCollapse = document.createElement('i');
      elmtCollapse.style.cursor = 'pointer';
      elmtCollapse.setAttribute('class', 'material-icons');
      elmtCollapse.innerHTML = 'compare_arrows';

      elmtCollapse.onclick = function () {
        it.toolbarService.collapseNode(nodeSelected, that, that.color);
        it.refreshToolbarNode(nodeSelected, that);
      };
      divAction.appendChild(elmtCollapse);
    }
    if (nodeSelected.data('collapsed') === 'true') {
      const elmtExpand = document.createElement('i');
      elmtExpand.style.cursor = 'pointer';
      elmtExpand.setAttribute('class', 'material-icons');
      elmtExpand.innerHTML = 'zoom_out_map';
      elmtExpand.onclick = function () {
        it.toolbarService.expandNode(nodeSelected, that);
        it.refreshToolbarNode(nodeSelected, that);

      };
      divAction.appendChild(elmtExpand);
    }
    if (nodeSelected.data('detached') === 'false' && nodeSelected.data('id') !== 'n') {
      // DETACHER
      const elmtDetach = document.createElement('i');
      elmtDetach.style.cursor = 'pointer';
      elmtDetach.setAttribute('class', 'material-icons');
      elmtDetach.innerHTML = 'link_off';
      elmtDetach.onclick = function () {
        it.nodeService.detachNode(nodeSelected, that);
        that.emitChange('update');
        it.refreshToolbarNode(nodeSelected, that);

      };
      divAction.appendChild(elmtDetach);
    }
    if (nodeSelected.data('detached') === 'true' && nodeSelected.data('id') !== 'n') {
      // ATTAcher
      const elmtAttach = document.createElement('i');
      elmtAttach.style.cursor = 'pointer';
      elmtAttach.setAttribute('class', 'material-icons');
      elmtAttach.innerHTML = 'link';
      elmtAttach.onclick = function () {
        // it
        // that.openModalAlert() ;

        that.nodeAttach = nodeSelected;
        that.onSelectNodeAttached.emit(that.nodeAttach);


      };
      divAction.appendChild(elmtAttach);
    }




    return divGlobal;
  }
  addToolbarNode(idNode, that) {
    const it = this;

    const nodeSelected = that.cy.nodes('[id="' + idNode + '"]');

    const nodePopper = nodeSelected.popper({

      content: function () {
        return it.createToolbarNode(idNode, that);
      }

    });

    const updatePopper = function () {
      nodePopper.scheduleUpdate();
    };

    nodeSelected.on('position', updatePopper);
    that.cy.on('pan zoom resize', updatePopper);

  }
  refreshToolbarNode(node, that) {
    // console.log('REFRESH', node.data())
    this.toolbarService.removeToolbarNode(node);
    this.addToolbarNode(node.data('id'), that);
  }
  // FIN PARTIE TOOLBAR


  // PARTIE NODE
  addChildNode(node = null, name, color, description, that) {
    const it = this;
    // Si node repliÃ© on le dÃ©plie
    if (node.data('collapsed') === 'true') {
      this.toolbarService.expandNode(node, that);
    }
    const nodeId = node.data('id');
    const nextId = this.nodeService.getUniqueNodeId(that);

    const newNode = that.cy.add({
      group: 'nodes',
      data: {
        id: nextId,
        label: name,
        collapsed: 'false',
        detached: 'false',
        color: color,
        description: description,
        last: 'true',
      }
    });
    const selector = 'node[id="' + nextId + '"]';
    that.cy.style().selector(selector).style({
      'background-color': color,
      'font-size': 10,
      'width': that.getWitdth(name)
    }).update();

    newNode.style('background-color', color);


    const newLinkId = nodeId + '-' + nextId;
    that.cy.add({ group: 'edges', data: { id: newLinkId, source: nodeId, target: nextId, secondary: 'false' } });

    node.data('collapsed', 'false');
    node.data('last', 'false');


    this.addToolbarNode(nextId, that);
    this.nodeService.updateColorBranchNode(newNode, color, that);

    this.refreshToolbarNode(node, that);
    this.toolbarService.hideToolbarNode(newNode);
    that.renderGraph();
    that.onCreate.emit(nextId);
    if (that.statusModal === 2) {
      this.eventService.emitNodeMiddle(newNode, that);
      newNode.data('last', 'false');

    }
    return nextId;


  }

  removeNode(that) {
    const node = that.nodeSelected;
    const nodeId = node.data('id');
    let listEdgeSecondary = node.connectedEdges('[secondary="' + true + '"]');
    if (listEdgeSecondary.length > 0) {
      delete listEdgeSecondary['_private'];
      delete listEdgeSecondary['length'];
      listEdgeSecondary = Object.values(listEdgeSecondary);
      let edge: any;
      for (edge in listEdgeSecondary) {
        edge = listEdgeSecondary[edge];
        const id = edge.data('id');
        that.cy.remove('edge[id="' + id + '"]');
      }
    }
    if (nodeId !== 'n') {
      that.onDelete.emit(nodeId);
      const listChildNodes = that.cy.edges(`[source="${nodeId}"]`);
      const keysChildNodes = Object.keys(listChildNodes);
      const parentNode = this.nodeService.getParentNode(node, that);
      const children = this.nodeService.getChildrenNode(node, that);

      if (children.length > 0) {
        parentNode.data('last', 'false');
      } else {
        parentNode.data('last', 'true');
      }
      for (const key of keysChildNodes) {
        let childNode = listChildNodes[key];

        if (childNode['_private']) {
          childNode = listChildNodes[key]['_private']['target'];
          $('#button' + nodeId).remove();
          that.cy.remove(childNode);
        }
        $('#toolbar-' + nodeId).remove();
        that.cy.remove(node);
      }
    }

    this.toolbarService.removeToolbarNode(node);
    that.hideAllToolbar();
    that.emitChange('update');
    that.closeModalDeleteNode();
  }
  // FIN PARTIE NODE
}
